module.exports = "<div id=\"banner-wrapper\">\n    <div id=\"banner-picture\"></div>\n    <div id=\"banner-content\" ng-transclude></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../~/noop-loader!./components/xo-ui-components/src/banner/template.html
// module id = ../node_modules/noop-loader/index.js!./components/xo-ui-components/src/banner/template.html
// module chunks = 1